import {Pipe} from "@angular/core";

@Pipe({
  name: 'intToFixedNumber',
  pure: false
})
export class IntToFixedNumberPipe {
  transform(value: number, digits: number = 2): string {
    return value.toFixed(digits);
  }
}
